import Checkbox from './Checkbox';

export default Checkbox;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rc-checkbox@2.1.4@rc-checkbox/es/index.js
// module id = 216
// module chunks = 0 1